export default function LoginPage(){return/*#__PURE__*/React.createElement("div",null,"Login Page");}